import { jsxs as t, jsx as i } from "react/jsx-runtime";
import e from "../../../svg-icon/svg-icon.component.js";
function r(l) {
  return /* @__PURE__ */ t(
    e,
    {
      width: "86",
      height: "38",
      viewBox: "0 0 86 38",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...l,
      children: [
        /* @__PURE__ */ t("g", { clipPath: "url(#DefaultBrandMarkNegative-clip0_34574_1984)", children: [
          /* @__PURE__ */ i(
            "path",
            {
              d: "M0.0859375 4.1095H6.85178V10.8384H15.087V16.8026H6.85178V27.0763C6.85178 29.2984 7.66887 30.7351 10.5106 30.7351H15.087V36.6994H10.5106C2.066 36.6985 0.0859375 32.0054 0.0859375 26.6755V4.1095Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M17.9082 4.10948C17.9082 1.32779 20.2753 0.0498047 22.0177 0.0498047C24.2329 0.0498047 26.0765 1.82044 26.0765 4.10948C26.0765 6.06294 24.4784 8.21894 22.0177 8.21894C19.2634 8.21894 17.9082 5.80288 17.9082 4.10948ZM18.6103 36.6985V10.8384H25.3761V36.6985H18.6103Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M53.5808 15.5238C51.8625 12.3173 48.5942 10.3364 44.4598 10.3364C39.7041 10.3364 37.1721 13.2133 36.3911 14.2132V10.8385H29.6252V36.6985H36.3911V22.215C36.3911 19.9028 37.6613 18.1098 39.2732 17.2284C40.1581 16.7443 41.1528 16.5014 42.2549 16.5014C43.4239 16.5014 44.4512 16.7443 45.337 17.2284C47.0441 18.1613 48.1187 19.9011 48.1187 22.215V36.6985H54.8845V21.0117C54.8845 18.9741 54.4502 17.1451 53.5816 15.5238H53.5808Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M65.7221 26.4747C65.1625 24.922 64.8758 22.4313 66.1693 20.0598C67.3468 17.9004 69.4702 16.552 72.0828 16.552C75.0001 16.552 76.9802 18.1965 77.9964 20.0598C79.2315 22.3249 79.0341 24.8362 78.4436 26.4747H85.66C85.8497 25.4979 86.6041 21.1593 84.085 16.9529C81.7059 12.9799 77.3896 10.3372 72.082 10.3372C66.4782 10.3372 62.2924 13.2528 60.0789 16.9529C57.5718 21.143 58.3022 25.4353 58.5039 26.4747H65.7212H65.7221Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M60.3192 30.9849C62.4589 34.3417 66.4293 37.1998 72.082 37.1998C77.0841 37.1998 81.3746 34.8584 83.8448 30.9849H60.3184H60.3192Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "clip0_34574_1984", children: /* @__PURE__ */ i("rect", { width: "85.9999", height: "37.2495", fill: "white" }) }) })
      ]
    }
  );
}
export {
  r as DefaultBrandMarkNegativeLogo
};
//# sourceMappingURL=negative.js.map
